const RECAPTCHA_TIMEOUT_MESSAGE = /^reCAPTCHA Timeout \([^)]+\)$/;

export const isRecaptchaTimeoutError = error => {
  const message =
    typeof error === "string"
      ? error
      : error && typeof error.message === "string"
      ? error.message
      : "";

  return RECAPTCHA_TIMEOUT_MESSAGE.test(message);
};

export const sentryEventHasRecaptchaTimeout = event =>
  Boolean(
    event &&
      event.exception &&
      Array.isArray(event.exception.values) &&
      event.exception.values.some(exception =>
        isRecaptchaTimeoutError(exception.value)
      )
  );
